import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { Question } from '../../../../models/suitability/question';
import { RadioQuestionComponent } from './radio-question/radio-question.component';
import { TextQuestionComponent } from './text-question/text-question.component';
import { MultiTextQuestionComponent } from './multi-text-question/multi-text-question.component';
import { MultiRadioQuestionComponent } from './multi-radio-question/multi-radio-question.component';

@Component({
  selector: 'app-suitability-question',
  templateUrl: './suitability-question.component.html',
  styleUrls: ['./suitability-question.component.scss']
})
export class SuitabilityQuestionComponent implements OnInit {
  @Input() question: Question;
  @Input() disabled = false;
  @Input() value: Question;

  @Output() questionSelected = new EventEmitter<Question>();

  @ViewChild(RadioQuestionComponent) radioQuestion: RadioQuestionComponent;
  @ViewChild(TextQuestionComponent) textQuestion: TextQuestionComponent;
  @ViewChild(MultiTextQuestionComponent)
  multiTextQuestion: MultiTextQuestionComponent;
  @ViewChild(MultiRadioQuestionComponent)
  multiRadioQuestion: MultiRadioQuestionComponent;

  constructor() {}

  ngOnInit() {}

  onAnswerEmmiter(answer: Question) {
    this.questionSelected.emit(answer);
  }

  isValidControl(): boolean {
    switch (this.question.questionType) {
      case 'Radio':
        return this.radioQuestion.isValidControl();

      case 'Text':
        return this.textQuestion.isValidControl();

      case 'MultiText':
        return this.multiTextQuestion.isValidControl();

      case 'MultiRadio':
        return this.multiRadioQuestion.isValidControl();

      default:
        return false;
    }
  }

  getQuestionID(): string {
    return this.question.id;
  }

  markControlAsTouched(): void {
    switch (this.question.questionType) {
      case 'Radio':
        this.radioQuestion.markControlAsTouched();
        break;

      case 'Text':
        this.textQuestion.markControlAsTouched();
        break;
      case 'MultiText':
        this.multiTextQuestion.markControlAsTouched();
        break;

      case 'MultiRadio':
        this.multiRadioQuestion.markControlAsTouched();
        break;

      default:
        break;
    }
  }
}
